import { serviceRequest } from 'utils/http';
import { ForgotPasswordDto, SiteEmployeeService } from 'common/api';

export function sendForgotPasswordEmailAPI(requestBody: ForgotPasswordDto) {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerSendForgotPasswordEmail(
      requestBody
    )
  );
}
